module.exports = __webpack_public_path__ + "static/img/rail-text-2.0ee03ab0.png";